import styled from 'styled-components';

export const StyledOrderListPage = styled('div')`
  .ant-table-row .ant-table-cell {
    padding: 16px 24px !important;
  }
`;
